export class ConfirmUserEmailDto {
  userId?: number;
  sendAsEmail?: string;
}
